import _ from 'lodash'
import moment from 'moment-timezone'
import { animateScroll } from 'react-scroll'
import uuidv5 from 'uuid/v5'
import { numeralFormat } from '@vzmi/component_ec_nodejs_util/dist/lib/renderUtil'

export * from '@vzmi/component_ec_nodejs_util/dist/lib/renderUtil'

export const getUuid = o => {
  const target = _.isString(o)
    ? o
    : JSON.stringify(o)

  return uuidv5(JSON.stringify(target), uuidv5.DNS)
}

export const evalEnv = (env) => {
  let isProduction = false
  let isDev = false
  switch (env) {
    case 'production':
    case 'preproduction': // pp
      isProduction = true
      break
    case 'development': // Beta
    case 'staging': // Beta
      isDev = true
      break
    default:
      // default as production
      isProduction = true
      isDev = false
      break
  }

  return {
    isProduction,
    isDev
  }
}

/* eslint-disable camelcase */
export const featureRouteFilter = (featureConfig) => {
  const defaultRoutes = require('../app/routes').default

  const nestedFilter = nestedRoutes => {
    return _.reduce(
      nestedRoutes,
      (result, route) => {
        const {
          flagName,
          routes
        } = route

        let localRoute = { ...route }

        if (!_.isEmpty(routes)) {
          localRoute = {
            ...localRoute,
            routes: nestedFilter(routes)
          }
        }

        if (flagName) {
          if (_.get(featureConfig, flagName)) {
            result.push(localRoute)
          }
        } else {
          result.push(localRoute)
        }
        return result
      }, [])
  }
  return nestedFilter(defaultRoutes)
}

export const getPeriodByBaseMoment = (baseMoment) => {
  const endOfPeriod = moment.isMoment(baseMoment) ? baseMoment.clone() : moment()
  const firstDayOfMonth = endOfPeriod.clone().startOf('month')
  return {
    start: firstDayOfMonth,
    end: endOfPeriod
  }
}

/**
 * 由輸入period參數來取德格式化後的區間字串
 */
export const generateFullPeriodFormat = (period) => {
  const start = moment.isMoment(period.start) ? period.start : moment(new Date(period.start))
  const end = moment.isMoment(period.end) ? period.end : moment(new Date(period.end))
  return `${start.startOf('day').format('YYYY-MM-DDTHH:mm:ssZ')}/${end.endOf('day').format('YYYY-MM-DDTHH:mm:ssZ')}`
}

/**
 * 由輸入的基礎時間來計算該月第一天至最後一天的區間物件
 */
export const getMonthlyPeriodByBaseMoment = (baseMoment) => {
  const base = baseMoment.clone() || moment()
  const startOfPeriod = moment(base.startOf('month'))
  const endOfPeriod = startOfPeriod.clone().endOf('month')
  return {
    start: startOfPeriod,
    end: endOfPeriod
  }
}

/**
 * 由輸入的基礎時間來計算該月第一天至最後一天的區間文字
 */
export const getMonthlyPeriodText = (baseMoment) => generateFullPeriodFormat(getMonthlyPeriodByBaseMoment(baseMoment))

/**
 * 取得基準日 (moment物件)
 *
 * 以目前時間的取得Moment物件做為基準值，依照以下規則：
  現在是 12:00:00 以後：今天(含)以後之日期不可選擇
  現在是 11:59:59 以前：前一天(含)以後之日期不可選擇

  簡而言之，目前時間超過十二點則，"基準日"等於一天前，
  若目前時間十二點前，則"基準日"為兩天前
*/
export const getBaseMomentByNoonGap = (inputNow) => {
  const current = inputNow ? moment(inputNow) : moment()
  const noonBase = current.clone().set({ hour: 12, minute: 0, second: 0, millisecond: 0 })

  if (current.isSameOrAfter(noonBase)) {
    return current.subtract(1, 'days')
  } else {
    return current.subtract(2, 'days')
  }
}

const { truncate, delay } = require('@vzmi/component_ec_nodejs_util/dist/lib/renderUtil')
export const getUserIdentity = (user = {}, opt = { length: 10 }) => {
  const { id, name } = user
  return user.simulated ? `${truncate(name, opt)} (模擬登入)` : id
}

export const eventPreventDefault = e => (e && e.preventDefault && e.preventDefault())

export const scrollToElement = (el, offset = 0) => {
  return delay(0).then(() => {
    const elemPos = el ? el.getBoundingClientRect().top + window.pageYOffset : 0
    animateScroll.scrollTo(elemPos + offset)
  })
}

export const scrollElementToCenter = (el) => {
  return scrollToElement(el, window.innerHeight / 2 * -1)
}

/** 取得 data-role="" 的 selector 字串 */
export const getDataRole = value => `[data-role="${value}"]`

export const getNumeralFormat = value => {
  return numeralFormat(value, { allowZero: true })
}

export const getNumberWithChineseUnit = (value, format = val => val) => {
  const num = _.toNumber(value)
  let convertedNum = num
  let unit = ''
  const TEN_THOUSAND = 10_000
  const HUNDRED_MILLION = 100_000_000
  switch (true) {
    case num >= HUNDRED_MILLION:
      convertedNum = (num / HUNDRED_MILLION)
      unit = '億'
      break
    case num >= TEN_THOUSAND:
      convertedNum = (num / TEN_THOUSAND)
      unit = '萬'
      break
    default:
      break
  }

  return `${format(convertedNum)}${unit}`
}
